import Title from "common/Typography/Title";
import Text from "common/Typography/Text";
import React from "react";
import Flex from "common/Boxes/Flex";
import { DomainIcon, SecurityIcon, TwoFAIcon } from "common/Icons/Icons";
import styled, { useTheme } from "styled-components";
import useMedia from "utils/hooks/useMedia";
import { LARGE_MOBILE } from "common/constants";

const SecuritySection = () => {
  const theme = useTheme();
  const isMobile = useMedia([`(max-width: ${LARGE_MOBILE})`], [true], false);

  const iconStyle = {
    width: "100%",
    height: "100%",
    fill: theme.colors.primaryGrey,
  };

  return (
    <Flex $flexDirection="column" style={{ marginBottom: isMobile ? 32 : 70 }}>
      <Title level={3}>Always verify:</Title>
      <ItemsWrapper
        $isMobile={isMobile}
        $flexDirection={isMobile ? "column" : "row"}
        $alignItems={isMobile ? "flex-start" : "center"}
      >
        <Flex>
          <IconBg>
            <DomainIcon style={iconStyle} />
          </IconBg>
          <StyledText>The domain is dashboard.cornix.io</StyledText>
        </Flex>
        <Flex>
          <IconBg>
            <SecurityIcon style={iconStyle} />
          </IconBg>
          <StyledText>The page uses https encryption</StyledText>
        </Flex>
        <Flex>
          <IconBg>
            <TwoFAIcon style={iconStyle} />
          </IconBg>
          <StyledText>You have two-factor auth (2FA) enabled</StyledText>
        </Flex>
      </ItemsWrapper>
    </Flex>
  );
};

export default SecuritySection;

const ICON_SIZE = 48;
const MOBILE_ICON_SIZE = 42;

const ItemsWrapper = styled(Flex)<{ $isMobile?: boolean }>`
  margin-top: 24px;
  max-width: 700px;
  width: 100%;
  column-gap: ${(p) => (p.$isMobile ? 12 : 16)}px;
  row-gap: 20px;
`;
const StyledText = styled(Text).attrs({ type: "secondary" })`
  flex: 1;
`;
const IconBg = styled.div`
  border-radius: 50px;
  background: ${(p) => p.theme.colors.lightBlue};
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${ICON_SIZE}px;
  height: ${ICON_SIZE}px;
  padding: 10px;
  margin-right: 16px;
  @media (max-width: ${LARGE_MOBILE}) {
    width: ${MOBILE_ICON_SIZE}px;
    height: ${MOBILE_ICON_SIZE}px;
    padding: 8px;
    margin-right: 12px;
  }
`;
